import { StockConfirmationStatusSchema } from '@diamond/shared/schema/order';
import { StockConfirmationStatus } from '@diamond/shared/types';
import { Value } from '@sinclair/typebox/value';

import { EstimatedWeightOrderDetailStatus } from './constants';

export type { StockConfirmationStatus };

export function readStockConfirmationStatus(
  product: object
): StockConfirmationStatus {
  const value = Reflect.get(product, 'stock_confirmation_status');
  if (Value.Check(StockConfirmationStatusSchema, value)) {
    return value;
  }

  return null;
}

export function mapStockConfirmationStatusToUi(
  status: StockConfirmationStatus,
  isFeatureEnabled: boolean
): EstimatedWeightOrderDetailStatus | null {
  if (!isFeatureEnabled || status == null) {
    return null;
  }

  switch (status) {
    case 'waiting_confirmation':
      return 'pending';
    case 'confirmed':
      return 'confirmed';
    default: {
      const _exhaustive: never = status;
      return _exhaustive;
    }
  }
}
